<template>
  <div class="text-gray-dark">
    <SectionTitle v-model="show">
      Nearby recommendations
    </SectionTitle>

    <div v-if="show">
      <div class="mb-2 text-right">
        <a v-if="showMap" href="javascript:void(0)" class="text-sm hover:text-black" @click.prevent="showMap = false">
          <svg
            class="-mt-1 inline-block"
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 6.75V6H7.5V6.75H0ZM0 3H12V3.75H0V3ZM9.75 0V0.75H0V0H9.75Z" fill="#4F4F4F" />
          </svg>
          List view
        </a>
        <a v-else href="javascript:void(0)" class="text-sm hover:text-black" @click.prevent="showMap = true">
          <svg
            class="-mt-1 inline-block"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11.25 12H0L2.25 5.25H5.25V3.71484C5.03125 3.66797 4.83008 3.58789 4.64648 3.47461C4.46289 3.36133 4.30469 3.22461 4.17188 3.06445C4.03906 2.90039 3.93555 2.7168 3.86133 2.51367C3.78711 2.31055 3.75 2.09766 3.75 1.875C3.75 1.61719 3.79883 1.375 3.89648 1.14844C3.99414 0.921875 4.12695 0.724609 4.29492 0.556641C4.4668 0.384766 4.66602 0.25 4.89258 0.152344C5.12305 0.0507812 5.36719 0 5.625 0C5.88281 0 6.125 0.0507812 6.35156 0.152344C6.57812 0.25 6.77539 0.384766 6.94336 0.556641C7.11523 0.724609 7.25 0.921875 7.34766 1.14844C7.44922 1.375 7.5 1.61719 7.5 1.875C7.5 2.09766 7.46289 2.31055 7.38867 2.51367C7.31445 2.7168 7.21094 2.90039 7.07812 3.06445C6.94531 3.22461 6.78711 3.36133 6.60352 3.47461C6.41992 3.58789 6.21875 3.66797 6 3.71484V5.25H9L11.25 12ZM4.5 1.875C4.5 2.03125 4.5293 2.17773 4.58789 2.31445C4.64648 2.45117 4.72656 2.57031 4.82812 2.67188C4.92969 2.77344 5.04883 2.85352 5.18555 2.91211C5.32227 2.9707 5.46875 3 5.625 3C5.78125 3 5.92773 2.9707 6.06445 2.91211C6.20117 2.85352 6.32031 2.77344 6.42188 2.67188C6.52344 2.57031 6.60352 2.45117 6.66211 2.31445C6.7207 2.17773 6.75 2.03125 6.75 1.875C6.75 1.71875 6.7207 1.57227 6.66211 1.43555C6.60352 1.29883 6.52344 1.17969 6.42188 1.07812C6.32031 0.976562 6.20117 0.896484 6.06445 0.837891C5.92773 0.779297 5.78125 0.75 5.625 0.75C5.46875 0.75 5.32227 0.779297 5.18555 0.837891C5.04883 0.896484 4.92969 0.976562 4.82812 1.07812C4.72656 1.17969 4.64648 1.29883 4.58789 1.43555C4.5293 1.57227 4.5 1.71875 4.5 1.875ZM1.04297 11.25H10.207L8.46094 6H6V8.8125C6 8.84766 5.98438 8.87891 5.95312 8.90625C5.92578 8.92969 5.89062 8.94922 5.84766 8.96484C5.80859 8.97656 5.76758 8.98633 5.72461 8.99414C5.68555 8.99805 5.65234 9 5.625 9C5.59766 9 5.5625 8.99805 5.51953 8.99414C5.48047 8.98633 5.43945 8.97656 5.39648 8.96484C5.35742 8.94922 5.32227 8.92969 5.29102 8.90625C5.26367 8.87891 5.25 8.84766 5.25 8.8125V6H2.78906L1.04297 11.25Z" fill="#4F4F4F" />
          </svg>
          Map view
        </a>
      </div>
      <div v-if="loading" class="mb-10 h-20 spinner" />
      <div v-if="venuesNearby.length">
        <div v-if="showMap">
          <VenueNearbyMap :venue="venue" :venues="venuesNearby" :destination="destination" />
        </div>

        <div v-else :class="{ 'opacity-50': loading }">
          <div class="nearby-carousel w-full">
            <CarouselType1 v-if="venuesNearby">
              <VenueNearbyVenue
                v-for="item in venuesNearby"
                :key="item.id"
                :venue="item"
                @click="venueClicked = item"
              />
            </CarouselType1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import CarouselType1 from '~/components/shared/CarouselType1'
import VenueNearbyVenue from '~/components/venue/VenueNearbyVenue'
import VenueNearbyMap from '~/components/venue/VenueNearbyMap'
import SectionTitle from '~/components/venue/SectionTitle'
import { useVenueStore } from '~/stores/venue'
import { useDestinationsStore } from '~/stores/destinations'

export default {
  components: { SectionTitle, VenueNearbyMap, VenueNearbyVenue, CarouselType1 },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => {
    return {
      show: true,
      venueClicked: null,
      showMap: true,
    }
  },

  computed: {
    ...mapState(useVenueStore, {
      venuesNearby: s => s.nearby.data,
      loading: s => s.nearby.loading,
    }),

    ...mapState(useDestinationsStore, {
      destination: s => s.destinations.destination.data,
    }),
  },

  beforeMount () {
    if (['sm', 'md'].includes(this.$screen.name)) {
      this.showMap = false
    }
  },
}
</script>

<style scoped lang="scss">
@media (min-width: 912px) {
  .nearby-carousel { max-width: 672px; }
}
:deep() {
  .slick-prev, .slick-next { top: calc(50% - 60px); }
}
</style>
